import {Card} from "../model/types";
import {MainDiamondsMobile} from "../ui/MainDiamondsMobile";
import {MainDiamondsDesktop} from "../ui/MainDiamondsDesktop";
import {Picture} from "@/shared/ui/Picture";
import {Link} from "@/shared/ui/Link";
import {Button} from "@/shared/ui/Button";
import styles from "./MainDiamonds.module.scss";

type Props = {
    cards: Card[];
    path: string;
    mobilePath: string;
    link: string;
    linkName: string;
    alt: string;
    isMobile: boolean;
}

export const MainDiamonds = ({cards, link, linkName, path, mobilePath, alt, isMobile}: Props) => {
    return (
        <div className={styles.container}>
            <div className={`globalContainer`}>
                <Picture src={path} srcMobile={mobilePath} alt={alt} classes={{root: styles.picture}} />
            </div>
            {isMobile ? <MainDiamondsMobile cards={cards} /> : <MainDiamondsDesktop cards={cards} />}
            <div className={`globalContainer`}>
                <Link href={link}><Button variant={`tertiary`} fullWidth>{linkName}</Button></Link>
            </div>
        </div>
    );
}
